import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListTable";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        overflow: auto;
        width: 100%;
    `,
};